<template>
    <v-container fluid pa-0>
         <v-card>
      <v-toolbar class="elevation-1">
        <v-toolbar-title>  
          Academic Data
        </v-toolbar-title>
        <v-spacer></v-spacer>
          <v-text-field
            append-icon="search"
            label="Search"
            flat
            v-model="search"
            solo
          ></v-text-field>
      </v-toolbar>
      <v-data-table
              :headers="headers"
              :items="items"
              item-key="id"
              :pagination.sync="pagination"
              :total-items="totalItems"
              :loading="loading"
              :rows-per-page-items="rowsPerPageItems"
            class="elevation-1"
          >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.studentName }}</td>
            <td>{{ props.item.taskName }}</td>
            <td>{{ props.item.courseName }}</td>
            <td>{{ props.item.dueDate }}</td>
            <td>{{ props.item.mark }}</td>
            <td>{{ props.item.weighting }}</td>
            <td>{{ props.item.termNumber }}</td>
            <td>{{ props.item.termWeighting }}</td>
          </template>
        </v-data-table>    
    </v-card>
    </v-container>
</template>

<script>
  import { getListByPeriod, initialize } from '../utils/effort-tracking-api'
  import { globalStore } from '../main'

  export default {
    data () {
      return {
        search: '',
        loading: true,
        totalItems: 0,
        rowsPerPageItems: globalStore.rowsPerPageItems ,
        pagination: { sortBy: 'name', rowsPerPage: globalStore.defaultRowsPerPage },
        headers: [
          { text: 'Name', value: 'studentName' },
          { text: 'Task', value: 'taskName' },
          { text: 'Course', value: 'courseName' },
          { text: 'Due Date', value: 'dueDate' },
          { text: 'Mark', value: 'mark' },
          { text: 'Task Weighting', value: 'weighting' },
          { text: 'Term Number', value: 'termNumber' },
          { text: 'Term Weighting', value: 'termWeighting' }
        ],
        items: []
      }
    },
     watch: {
      search: {
        handler () {
           this.debouncedGetDataFromApi()
        },
      },
      pagination: {
        handler () {
            this.debouncedGetDataFromApi()
        },
        deep: true
      }
    },
    mounted () {
        this.debouncedGetDataFromApi = _.debounce(this.getDataFromApi, 500, { trailing:true })
    },
    methods: {
      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      getDataFromApi () {
        initialize().then(x => {
            this.loading = true;
            getListByPeriod("studenttasks", this.pagination, this.search).then(data => {
                console.log(data);
                this.items = data.items
                this.totalItems = data.count
                this.loading = false;   
            })
        });
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/AcademicData.vue